<div class="zwi-series-list">
  <ng-content></ng-content>
</div>
